import app from 'store/models/app';
import auth from 'store/models/auth';
import chatRoom from 'store/models/chat-room';
import websocket from 'store/models/websocket';
import webRtcCall from 'store/models/web-rtc-call';
import search from './search';
import packages from 'store/models/packages';
export default {
  app,
  auth,
  chatRoom,
  websocket,
  webRtcCall,
  search,
  packages,
};
